'use strict';

import {ngDepModel} from './ngdepmodel.js';

export class irregularityModel extends ngDepModel
{
		
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}
	
	
	getValue(name){
		switch(name){
			case 'status':
				return this.getClassifValue(name, 'irregularity_status');
			case 'has_irregularity_detected':
				return this.getClassifValue(name, 'yesno');
			case 'date':
			case 'created':
			case 'decision_date':
				if(this[name] == 0){
					return '';
				}
				return this.s('$filter')('u2date')(this[name]);
		}
		if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
			return this[name];
		}
		return null;
	}
	
}